import React, { memo } from 'react'
import moment from 'moment'
import { IconButton } from 'transfix-ui/components/IconButton'
import { DRIVER_IN_OUT_FORM_STATE } from 'apps/fleet-planner/hooks/useDriverInOutForm'
import { IStop } from 'apps/fleet-planner/types/loads'
import { ITimeFormats } from 'apps/fleet-planner/utils/userDateTimeSettings'
import { EditIcon } from 'transfix-icons'
import { FORMATS } from 'constants/datetime'
import { DISPLAY } from 'constants/display'

interface IDropTrailerTimesProps {
  isEditable?: boolean
  displayTimezone?: string
  sequence: number
  timeFormats: ITimeFormats
  onButtonClick?: (state: DRIVER_IN_OUT_FORM_STATE) => void
  stop: Partial<IStop>
}

const INVALID_DATE = 'Invalid date'

export const DropTrailerTimes = memo<IDropTrailerTimesProps>(
  ({ displayTimezone, isEditable = false, onButtonClick, sequence, stop }) => {
    const openCheckOutHandler = () => {
      if (onButtonClick) onButtonClick(DRIVER_IN_OUT_FORM_STATE.dropTrailer)
    }

    const { dropTrailerArrivedAt, dropTrailerEmptyAt, stopType } = stop || {}

    const arrivedAt = moment
      .tz(dropTrailerArrivedAt, displayTimezone as string)
      .format(FORMATS.monthDayTimeFormatShort12h)
    const emptyAt = moment
      .tz(dropTrailerEmptyAt, displayTimezone as string)
      .format(FORMATS.monthDayTimeFormatShort12h)

    const dropTrailer = stopType === 'pickup' ? arrivedAt : emptyAt

    return (
      <div className='flex items-center'>
        {dropTrailer !== INVALID_DATE ? (
          <p data-test={`drop-trailer-${stopType}-${sequence}`} className='body-semibold'>
            {dropTrailer}
          </p>
        ) : (
          <p
            data-test={`drop-trailer-empty-${stopType}-${sequence}`}
            className='pl2 text-secondary'>
            {DISPLAY.empty}
          </p>
        )}

        {onButtonClick && isEditable && (
          <IconButton
            className='clear-filter'
            Icon={EditIcon}
            onClick={openCheckOutHandler}
            label='Drop Trailer Times'
            size='large'
          />
        )}
      </div>
    )
  }
)
